import React from 'react';
import { Lock, Plus, Users } from 'lucide-react';
import { GROUPS } from '../../data/workspaceTracks';
import { Glyph, MetaStat, Panel, PrimaryAction, Row, RowText, ScreenHeader } from './ui';

// ── Groups ───────────────────────────────────────────────────────────────────
// Groups are the access boundary: every track, file, connection and table belongs
// to one, and only its members can see what's inside.
//
// Rebuilt on the shared primitives in ./ui.tsx. Two changes worth naming:
//   1. A grid of bordered boxes became one panel of rows. Access and counts are
//      values you compare DOWN a column, and a grid gives you no column.
//   2. The four counts lost their 11px icons. Four tiny glyphs beside four tiny
//      numbers is eight marks carrying the information of four; the number is
//      the fact, so it leads and the word labels it.
// No copy or data changed.
// ─────────────────────────────────────────────────────────────────────────────

export function GroupsView() {
  return <div data-id="element-2896" data-mp="wi2xspel93gk">
      <ScreenHeader title="Groups" description="A group decides who can see what. Tracks, files, connections and tables all belong to a group, so access follows the group rather than being set item by item." action={<PrimaryAction label="New group" data-id="element-2898" data-mp="mjdgaxqltl0u">
            <Plus size={15} data-id="element-2899" data-mp="rj9gelw6ksb4" />
            New group
          </PrimaryAction>} data-id="element-2897" data-mp="wjdy2f8trt2x" />

      <Panel className="mt-6" data-id="element-2900" data-mp="rlcgxzuym3u3">
        {GROUPS.map(group => <Row key={group.name} className="flex-wrap gap-y-4 md:flex-nowrap" data-id="element-2901" data-mp="cu3olizoa4d9">
            <Glyph icon={group.shared ? Users : Lock} data-id="element-2902" data-mp="hktt6u09y36w" />
            <RowText title={group.name} meta={`${group.shared ? 'Shared' : 'Private'} · ${group.members === 1 ? '1 member' : `${group.members} members`}`} data-id="element-2903" data-mp="hmd92ji0qc85" />

            {/* Fixed-width columns so the numbers line up down the panel — the
             whole reason this is a list rather than a grid. */}
            <dl className="flex w-full shrink-0 items-start gap-6 md:w-auto md:gap-8" data-id="element-2904" data-mp="3q1ndvzdalvjm">
              <span className="w-12" data-id="element-2905" data-mp="3uzgiwp2v0jib">
                <MetaStat label="Tracks" value={group.tracks} data-id="element-2906" data-mp="3bvd7hqjc0qtd" />
              </span>
              <span className="w-12" data-id="element-2907" data-mp="3bx6e55ty3b1d">
                <MetaStat label="Files" value={group.files} data-id="element-2908" data-mp="374d72bb07qm4" />
              </span>
              <span className="w-12" data-id="element-2909" data-mp="325abriktsyrc">
                <MetaStat label="Links" value={group.connections} data-id="element-2910" data-mp="326bqpy4yq5ec" />
              </span>
              <span className="w-12" data-id="element-2911" data-mp="2x7i9pvqgvw9f">
                <MetaStat label="Tables" value={group.tables} data-id="element-2912" data-mp="2x4cmyn5b96gv" />
              </span>
            </dl>
          </Row>)}
      </Panel>
    </div>;
}